import { Badge, Button, Card, DatePicker, Divider, Form, Input, List, PageHeader, Select, Space, Switch, Table, Tag, Tooltip, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Router, useHistory } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { getTrainingOptions, getTrainings } from "../../appRedux/actions";
import { useEffect, useState } from "react";
import { baseRequest } from "../../util/Api";
import moment from "moment";
import { toRupiah } from "../../libs";
import { createTrainingBundle, getTrainingBundle, updateTrainingBundle } from "../../appRedux/actions/TrainingBundles";
import { use } from "react";

export default function NewTrainingBundle() {
  // const backgroundColor = "#faf70d";
  const history = useHistory();
  const [form] = Form.useForm();
  const [locations, setLocations] = useState([]);
  const [selectedTrainings, setSelectedTrainings] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();

  const { trainings, getTrainingsLoading } = useSelector(
    ({ training }) => training
  );
  const { trainingOptions, getTrainingOptionsLoading } = useSelector(
    ({ trainingOption }) => trainingOption
  );

  useEffect(async () => {
    const data = await baseRequest("get", "/trainings/locations", null);
    let options = [{ value: null, label: "Semua" }];
    data.map((value) => {
      options.push({
        value: value,
        label: value,
      });
    });
    setLocations(options);
  }, []);


  useEffect(async () => {
    if (!id || trainingOptions.length === 0)
      return;
    
    getTrainingBundle(id).then(data => {
      form.setFieldsValue({
        name: data.name,
        price: data.price,
        enabled: data.enabled
      });
      let selected = [];
      data.training_bundles_trainings.map(bundle_training => {
        const training = data.trainings.find((t) => t.id === bundle_training.training_id);
        selected.push({
          training_option_id: bundle_training.training_option_id,
          training_option_name: trainingOptions.find((t) => t.id === bundle_training.training_option_id).name,
          is_online: bundle_training.is_online,
          location: bundle_training.location,
          training_id: bundle_training.training_id,
          training_name: training ? training.name : null,
          year: bundle_training.year,
          month: bundle_training.month,
          dates_summary: training ? training.dates_summary : null,
          // price: training ? training.price : null,
          id: bundle_training.id,
        });
      });
      setSelectedTrainings(selected);
    });
  }, [id, trainingOptions]);

  // useEffect(() => {
  //   if (trainings.length < 1) {
  //     form.setFieldsValue({ training_id: null });
  //   } else {
  //     form.setFieldsValue({ training_id: trainings[0].id });
  //   }
  // }, [trainings]);

  useEffect(() => {
    dispatch(getTrainingOptions({ page_size: 1000 }));
  }, [dispatch]);

  function addTraining() {
    const trainingId = form.getFieldValue("training_id");
    let training = null;
    if (trainingId) {
      training = trainings.find((t) => t.id === trainingId);
      if (!training)
        return;
    }
    const selectedTraining = selectedTrainings.find((t) => t.id === trainingId);
    if (selectedTraining)
      return;
    setSelectedTrainings([...selectedTrainings, {
      training_option_id: form.getFieldValue("training_option_id"),
      training_option_name: trainingOptions.find((t) => t.id === form.getFieldValue("training_option_id")).name,
      is_online: form.getFieldValue("training_type") === "online" ? true : (form.getFieldValue("training_type") === "offline" ? false : null),
      location: form.getFieldValue("training_location"),
      training_id: form.getFieldValue("training_id"),
      training_name: training ? trainings.find((t) => t.id === form.getFieldValue("training_id")).name : null,
      year: moment(form.getFieldValue("training_dates")).year(),
      month: moment(form.getFieldValue("training_dates")).month() + 1,
      dates_summary: training ? training.dates_summary : null,
      // price: training ? training.price : null,
      // training_dates: form.getFieldValue("training_dates"),
      id: Date.now(),
    }]);
  }

  function deleteTraining(id) {
    setSelectedTrainings(selectedTrainings.filter((t) => t.id !== id));
  }

  return <>
    <PageHeader
      ghost={false}
      title={id ? "Edit Training Bundle" : "Tambah Training Bundle"}
      onBack={() => history.goBack()}
    />
    <Card bordered={false} style={{ borderRadius: 0 }}>
      <Form
        scrollToFirstError={true}
        form={form}
        layout="vertical"
        initialValues={{
          training_dates: null, //moment(),
          enabled: true,
          training_type: null,
          training_location: null,
          training_option_id: null,
        }}
        onValuesChange={(changedValues, allValues) => {
          if (
            "training_option_id" in changedValues ||
            "training_type" in changedValues ||
            "training_location" in changedValues ||
            "training_dates" in changedValues
          ) {
            if (allValues.training_option_id && allValues.training_type && allValues.training_dates) {
              dispatch(getTrainings({
                training_option_id: allValues.training_option_id,
                is_online: allValues.training_type === "online",
                location:
                  allValues.training_type === "offline"
                    ? (allValues.training_location ? allValues.training_location : "XXXXXXXXXX")
                    : null,
                start_date: allValues.training_dates
                  .startOf("month")
                  .toISOString(),
                end_date: allValues.training_dates.endOf("month").toISOString(),
              }));
            }
          }
        }}
        onFinish={(values) => {
          let result = {};
          result.name = values.name;
          result.price = values.price;
          result.enabled = values.enabled;
          result.training_bundles_trainings = selectedTrainings;//.map((t) => t.id);
          if (id)
            updateTrainingBundle(id, result).then(() => {
              history.push("/training-bundle");
            });
          else
            createTrainingBundle(result).then(() => {
              history.push("/training-bundle");
            });
        }}
      >
        <Form.Item
          label="Nama Training Bundle"
          name="name"
          rules={[{ required: true, message: "Mohon isikan nama training bundle" }]}
        >
          <Input placeholder="Nama training bundle" />
        </Form.Item>
        <Form.Item
          label="Harga Training Bundle"
          name="price"
          rules={[
            { required: true, message: "Mohon isikan harga training bundle" },
            { type: 'number', min: 500000, message: "Harga minimal adalah Rp500.000", transform: (value) => Number(value) }
          ]}
        >
          <Input
            prefix="Rp"
            type="number"
            placeholder="Harga training bundle"
            onKeyDown={(e) =>
              !/[0-9]/.test(e.key) && e.key !== "Backspace" && e.preventDefault()
            }
          />
        </Form.Item>
        <Form.Item
          valuePropName="checked"
          name="enabled"
          label="Diaktifkan"
        >
          <Switch />
        </Form.Item>
        <Form.Item label="Training yang Dipilih">
          <Table
            pagination={false}
            size="small"
            rowKey="id"
            dataSource={selectedTrainings}
            columns={[
              {
                title: "Tipe",
                dataIndex: "is_online",
                key: "is_online",
                render: (isOnline, field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: (
                      <>
                        {(isOnline === true) &&
                          <Tag color="green" style={{ margin: 1 }}>ONLINE</Tag>
                        }
                        {(isOnline === false) &&
                          <Tag color="blue" style={{ margin: 1 }}>OFFLINE</Tag>
                        }
                        {(isOnline === null) &&
                          <Tag color="red" style={{ margin: 1 }}>Semua</Tag>
                        }
                      </>
                    )
                  }
                },
              },
              {
                title: "Nama",
                dataIndex: "training_option_name",
                key: "training_option_name",
                render: (training_option_name, field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: <div>{training_option_name}</div>
                  }
                },
              },
              {
                title: "Lokasi",
                dataIndex: "location",
                key: "location",
                render: (location, field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: (
                      <div>{location ? location : "Semua"}</div>
                    )
                  }
                },
              },
              {
                title: "Bulan",
                dataIndex: "year",
                key: "year",
                render: (year, field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: (
                      <div>{year ? moment(field.year + "-" + field.month, "YYYY-MM").format("MMMM YYYY") : "Semua"}</div>
                    )
                  }
                },
              },
              {
                title: "Jadwal",
                dataIndex: "dates_summary",
                key: "dates_summary",
                render: (datesSummary, field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: (
                      (datesSummary ? datesSummary : "Semua")
                    )
                  }
                },
              },
              // {
              //   title: "Harga",
              //   dataIndex: "price",
              //   key: "price",
              //   responsive: ["md"],
              //   render: (text, field) => {
              //     return {
              //       // props: {
              //       //   style: { background: !field.is_running ? backgroundColor : "" }
              //       // },
              //       children: (
              //         <>
              //           <Tooltip title="Harga">
              //             <Tag color="red" style={{ margin: 1 }}>{text ? toRupiah(text) : "Semua"}</Tag>
              //           </Tooltip>
              //         </>
              //       )
              //     }
              //   },
              // },
              {
                key: "action",
                align: "right",
                render: (field) => {
                  return {
                    // props: {
                    //   style: { background: !field.is_running ? backgroundColor : "" }
                    // },
                    children: <>
                      <Button danger onClick={() => deleteTraining(field.id)}>Hapus</Button>
                    </>,
                  }
                },
              }
            ]}
          />
        </Form.Item>
        <Divider />
        <Card>
          <Space wrap>
            <Form.Item
              label="Pilihan training"
              name="training_option_id"
              loading={getTrainingOptionsLoading}
            >
              <Select
                showSearch
                placeholder="pilih pilihan training"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: "16rem" }}
              >
                {trainingOptions.map((t) => (
                  <Select.Option key={t.id} value={t.id} label={t.name}>
                    {t.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <Form.Item label="Tipe training" name="training_type" defaultValue={null}>
                  <Select disabled={form.getFieldValue("training_option_id") === null}>
                    <Select.Option value={null}>Semua</Select.Option>
                    <Select.Option value="offline">Offline</Select.Option>
                    <Select.Option value="online">Online</Select.Option>
                  </Select>
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <Form.Item
                  label="Lokasi training"
                  name="training_location"
                  defaultValue={null}
                // disabled={
                //   form.getFieldValue("training_type") === "online"
                // }
                // style={{
                //   display:
                //     form.getFieldValue("training_type") === "offline" ||
                //     form.getFieldValue("training_type") === null
                //       ? "block"
                //       : "none",
                // }}
                >
                  <Select
                    options={locations}
                    disabled={form.getFieldValue("training_type") === "online" || form.getFieldValue("training_option_id") === null}>
                  </Select>
                </Form.Item>
              )
              }
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <Form.Item label="Bulan training" name="training_dates">
                  <DatePicker
                    picker="month"
                    format="MMMM YYYY"
                    allowClear={true}
                    disabled={form.getFieldValue("training_option_id") === null}
                  />
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <Form.Item
                  label="Jadwal training"
                  name="training_id"
                >
                  <Select
                    placeholder="pilih jadwal training"
                    loading={getTrainingsLoading}
                    disabled={
                      form.getFieldValue("training_option_id") === null ||
                      form.getFieldValue("training_option_id") === undefined
                    }
                  >
                    {trainings.map((t) => (
                      <Select.Option key={t.id} value={t.id} disabled={!t.is_running}>
                        {t.dates_summary}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {() => (
                <Button
                  type="primary"
                  onClick={addTraining}
                  disabled={form.getFieldValue("training_option_id") === null}
                  style={{ alignSelf: 'flex-end', margin: '0', marginTop: '0.5rem' }}>
                  Tambah Training
                </Button>
              )}
            </Form.Item>
          </Space>
        </Card>
        <Form.Item>
          <center>
            <Button type="primary" htmlType="submit" disabled={selectedTrainings.length < 2}>
              Simpan
            </Button>
          </center>
        </Form.Item>
      </Form>
    </Card>
  </>
}